export default __webpack_public_path__ + "static/media/16t.5f278c5d.jpg";